import React, { Suspense, useEffect, useState } from 'react'
import Header from './components/Header'
import HeroSection from './components/HeroSection'
import Lenis from 'lenis'

// Lazy load ALL sections after Hero - Hero video is ONLY priority
const FeaturesSection = React.lazy(() => import('./components/FeaturesSection'))
const KeyHighlightsSection = React.lazy(() => import('./components/KeyHighlightsSection'))
const DigitalRehearsalSection = React.lazy(() => import('./components/DigitalRehearsalSection'))
const ReviewSmarterSection = React.lazy(() => import('./components/ReviewSmarterSection'))
const ComponentLibrarySection = React.lazy(() => import('./components/ComponentLibrarySection'))
const ComparisonTableSection = React.lazy(() => import('./components/ComparisonTableSection'))
const CaseStudiesSection = React.lazy(() => import('./components/CaseStudiesSection'))
const BenefitsSection = React.lazy(() => import('./components/BenefitsSection'))
const EngineeredSection = React.lazy(() => import('./components/EngineeredSection'))
const ContactSection = React.lazy(() => import('./components/ContactSection'))
const Footer = React.lazy(() => import('./components/Footer'))

function LandingPage({ onLogin }) {
  // Handles login click: triggers authentication if not already authenticated
  const handleLogin = () => {
    if (onLogin) {
      onLogin()
    } else {
      // window.location.replace('/home')
      alert('Login function not provided. Please implement the onLogin prop.1')
    }
  }

  const [isMobile, setIsMobile] = useState(false)

//   useEffect(() => {
//     // If user is authenticated (cookie still present after attempted delete), redirect to /home
//     console.log('Checking authentication status...')
//     if (getCookie('bb_metaverse_token')) {
//       setIsAuthenticated(true)
//     //   window.location.replace('/home')
//     }
//   }, [])

  useEffect(() => {
    const handleResize = () => {
      // Treat iPad Pro Portrait (1024px) and below as mobile/tablet
      setIsMobile(window.innerWidth <= 1024)
    }

    handleResize()
    window.addEventListener('resize', handleResize)

    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      mouseMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
    })

    function raf(time) {
      lenis.raf(time)
      requestAnimationFrame(raf)
    }

    requestAnimationFrame(raf)

    return () => {
      lenis.destroy()
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  if (isMobile) {
    return (
      <div
        style={{
          minHeight: '100vh',
          margin: 0,
          padding: 0,
          background:
            'transparent radial-gradient(closest-side at 50% 100%, #2C2C2C 0%, #111111 64%, #000000 100%) 0% 0% no-repeat padding-box',
          fontFamily: '"Univers", "Univers Condensed", "Arial Narrow", sans-serif',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Header simple onLogin={handleLogin} />
        <div
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
            textAlign: 'center'
          }}
        >
          <h1
            style={{
              fontSize: 'clamp(32px, 5vw,32px)',
              fontWeight: '700',
              textAlign: 'center',
              marginBottom: '24px',
              marginTop: '0',
              lineHeight: '1.1',
              letterSpacing: '-0.02em',
              fontFamily: "'Univers', 'Roboto', sans-serif",
              background: 'linear-gradient(90deg, #D7DF23 0%, #D7DF23 43%, #8B1D8A 100%) 0% 0% no-repeat padding-box',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              color: 'transparent',
              maxWidth: '90%'
            }}
          >
            Desktop-first experience delivered.
          </h1>
          <p
            style={{
              fontSize: 'clamp(12px, 2vw, 20px)',
              letterSpacing: '0px',
              color: '#FFFFFF',
              textAlign: 'center',
              margin: 0,
              lineHeight: '1.5',
              fontFamily: "'Univers', 'Roboto', sans-serif",
              fontWeight: '400',
              maxWidth: '600px'
            }}
          >
            Responsive support is planned and currently in progress.
          </p>
        </div>
      </div>
    )
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        margin: 0,
        padding: 0,
        background:
          'transparent radial-gradient(closest-side at 50% 100%, #2C2C2C 0%, #111111 64%, #000000 100%) 0% 0% no-repeat padding-box',
        fontFamily: '"Univers", "Univers Condensed", "Arial Narrow", sans-serif'
      }}
    >
      <Header onLogin={handleLogin} />
      <HeroSection />
      <Suspense fallback={<div style={{ height: '50vh' }} />}>
        <FeaturesSection />
        <DigitalRehearsalSection />
        <KeyHighlightsSection />
        <ReviewSmarterSection />
        <ComponentLibrarySection />
        <ComparisonTableSection />
        <CaseStudiesSection />
        <EngineeredSection />
        <BenefitsSection />
        <ContactSection />
        <Footer />
      </Suspense>
    </div>
  )
}

export default LandingPage
